<template>
    <div class="menu-page">
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
                @search-change="searchChange" @refresh-change="refreshChange" @row-save="handleSave"
                @row-update="handleUpdate" @size-change="pageSizeChange" @current-change="pageChange">

                <template slot-scope="scope" slot="menuLeft">
                    <el-button type="primary" icon="el-icon-plus" size="small" plain title="新增菜单"
                        v-if="permission.JOINS_SALES_CLOUD_MENU_ADD" @click.stop="handleAdd()">新增
                    </el-button>
                    <el-button type="warning" icon="el-icon-delete" size="small" plain
                        title="逻辑删除：仅标记删除，数据可恢复"
                        v-if="permission.JOINS_SALES_CLOUD_MENU_DEL"
                        @click.stop="handleDel('DELETE_OPTION', '逻辑删除')">逻辑删除
                    </el-button>
                    <el-button type="danger" icon="el-icon-delete" size="small" plain
                        title="物理删除：直接从数据库移除，不可恢复"
                        v-if="permission.JOINS_SALES_CLOUD_MENU_DEL"
                        @click.stop="handleDel('DELETE_OPTION', '物理删除')">物理删除
                    </el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button type="primary" icon="el-icon-edit" size="small" plain title="编辑菜单"
                        v-if="permission.JOINS_SALES_CLOUD_MENU_EDIT" @click.stop="handleEdit(scope.row, scope.index)">编辑
                    </el-button>
                </template>
                <template slot-scope="scope" slot="superiorId">
                    <el-tag v-if="null != scope.row.superiorName">{{ scope.row.superiorName }}</el-tag>
                    <span v-else>-</span>
                </template>
                <template slot-scope="scope" slot="typeForm">
                    <span v-if="isViewScope(scope)">{{ typeText(scope) }}</span>
                    <el-select v-else v-model="menuType" placeholder="请选择菜单类型" @change="onMenuTypeChange"
                        value-key="value" clearable>
                        <el-option v-for="item in menuTypes" :key="item.value" :label="item.label"
                            :value="item"></el-option>
                    </el-select>
                </template>

                <template slot-scope="scope" slot="superiorIdForm">
                    <span v-if="isViewScope(scope)">{{ (scope.row && scope.row.superiorName) || '-' }}</span>
                    <template v-else>
                        <el-select v-model="superior" placeholder="请选择上级菜单" clearable filterable value-key="id">
                            <el-option v-for="item in superiors" :key="item.id" :label="item.name"
                                :value="item"></el-option>
                        </el-select>
                        <div class="form-tip" v-if="!isDirectory && !superiors.length">暂无可选的上级菜单</div>
                    </template>
                </template>
                <template slot-scope="scope" slot="icon">
                    <i v-if="scope.row.icon" :class="scope.row.icon" class="icon-cell" :title="scope.row.icon"></i>
                    <span v-else>-</span>
                </template>
                <template slot-scope="scope" slot="iconForm">
                    <span v-if="isViewScope(scope)" class="icon-preview">
                        <i v-if="scope.row.icon" :class="scope.row.icon"></i>
                        <span class="icon-name">{{ scope.row.icon || '-' }}</span>
                    </span>
                    <div v-else class="icon-field">
                        <el-input v-model="scope.row.icon" :prefix-icon="scope.row.icon" size="small" clearable
                            placeholder="点击右侧按钮选择，或直接输入 el-icon-xxx" />
                        <el-button type="primary" size="small" plain icon="el-icon-search"
                            @click="openIconPicker(scope.row)">选择图标</el-button>
                    </div>
                </template>
            </avue-crud>

            <!-- 图标选择器：必须 append-to-body，否则会被 avue 的表单弹窗盖住 -->
            <el-dialog title="选择图标" :visible.sync="iconPickerVisible" width="760px" append-to-body
                @close="iconEditingRow = null">
                <div class="icon-picker">
                    <div class="icon-picker__bar">
                        <el-radio-group v-model="iconMode" size="small" @change="iconPage = 1">
                            <el-radio-button label="common">常用</el-radio-button>
                            <el-radio-button label="all">全部</el-radio-button>
                        </el-radio-group>
                        <el-input v-model="iconKeyword" size="small" clearable prefix-icon="el-icon-search"
                            placeholder="搜索图标名，如 home" class="icon-picker__search" @input="iconPage = 1" />
                    </div>

                    <div class="icon-picker__grid" v-if="pagedIcons.length">
                        <div v-for="icon in pagedIcons" :key="icon" class="icon-item" :title="icon"
                            :class="{ 'is-active': iconEditingRow && iconEditingRow.icon === icon }"
                            @click="pickIcon(icon)">
                            <i :class="icon"></i>
                            <span>{{ iconText(icon) }}</span>
                        </div>
                    </div>
                    <div v-else class="icon-picker__empty">未找到匹配的图标</div>

                    <el-pagination v-if="iconTotal > iconPageSize" small layout="prev, pager, next"
                        :total="iconTotal" :page-size="iconPageSize" :current-page.sync="iconPage"
                        class="icon-picker__page" />
                </div>
                <div slot="footer">
                    <span class="icon-picker__count">共 {{ iconTotal }} 个图标</span>
                    <el-button size="small" @click="iconPickerVisible = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="iconPickerVisible = false">确 定</el-button>
                </div>
            </el-dialog>
        </basic-container>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { menuTableOption } from "@/const/salesCloud/menuOption";
import {
    findMenu,
    addMenu,
    editMenu,
    delMenu,
    findSuperiorMenusByType
} from "@/api/salesCloud/menu"
import { findByLabel } from "@/util/util"
import { DIC } from "@/const/dic"
import { MENU_ICONS, MENU_ICONS_COMMON } from "@/const/salesCloud/menuIcons"

export default {
    name: "menu",
    components: {},
    data() {
        return {
            tableOption: menuTableOption, //表格设置属性
            tableData: [], //表格的数据
            tableLoading: false,
            page: {
                total: 0, //总条数
                currentPage: 1, //当前页数
                pageSize: 10 //每页显示多少条
            },
            superiors: [], //当前菜单类型下可选的上级菜单
            superior: {}, //已选中的上级菜单
            menuTypes: DIC.MENU_TYPE,
            menuType: {}, //已选中的菜单类型
            listSeq: 0, //列表请求序号，防止快速翻页时旧响应覆盖新数据
            superiorCache: {}, //按菜单类型缓存上级菜单，避免每次编辑都请求
            iconPickerVisible: false, //图标选择弹窗
            iconMode: 'common', //common 常用 / all 全部
            iconKeyword: '',
            iconPage: 1,
            iconPageSize: 80,
            iconEditingRow: null, //正在选择图标的表单行引用
        };
    },
    created() {
        this.loadList();
    },
    computed: {
        ...mapGetters(["permission"]),
        isDirectory() {
            return !!this.menuType && this.menuType.value === 'DIRECTORY';
        },
        filteredIcons() {
            const kw = (this.iconKeyword || '').trim().toLowerCase();
            const source = this.iconMode === 'common' ? MENU_ICONS_COMMON : MENU_ICONS;
            if (!kw) return source;
            return source.filter((item) => item.toLowerCase().indexOf(kw) !== -1);
        },
        iconTotal() {
            return this.filteredIcons.length;
        },
        pagedIcons() {
            const start = (this.iconPage - 1) * this.iconPageSize;
            return this.filteredIcons.slice(start, start + this.iconPageSize);
        }
    },
    methods: {
        /**
         * 统一解析接口响应。后端返回 { code, message, data }，其中 data 是 JSON 字符串。
         * 解析失败时返回兜底值，避免整页报错。
         */
        parseResp(res, fallback) {
            try {
                const raw = res && res.data;
                const data = typeof raw === 'string' ? JSON.parse(raw) : raw;
                return data == null ? fallback : data;
            } catch (e) {
                console.error('[menu] 响应解析失败', e);
                return fallback;
            }
        },
        /**
         * 统一错误提示。catch 里拿到的是 Error 对象，
         * 直接塞给 $message 会显示 [object Object]，这里提取可读文案。
         */
        showError(err, fallback) {
            const msg = err && (err.message ||
                (err.response && err.response.data && err.response.data.message));
            console.error('[menu]', fallback, err);
            this.$message({
                showClose: true,
                message: msg || fallback || '操作失败，请稍后重试',
                type: "error"
            });
        },
        /** 统一列表加载，集中处理 loading、异常与响应竞态 */
        loadList(override) {
            const seq = ++this.listSeq;
            this.tableLoading = true;
            // 复制一份，避免把分页参数写回 searchForm 影响后续搜索
            const search = Object.assign({}, this.$refs.crud && this.$refs.crud.searchForm);
            const params = Object.assign(search, {
                page: this.page.currentPage,
                size: this.page.pageSize
            }, override || {});

            findMenu(params).then((res) => {
                if (seq !== this.listSeq) return; //已发起新请求，丢弃本次过期响应
                const data = this.parseResp(res, { rows: [], total: 0 });
                this.tableData = Array.isArray(data.rows) ? data.rows : [];
                this.page = {
                    total: data.total || 0,
                    currentPage: params.page,
                    pageSize: params.size
                };
                this.tableLoading = false;
            }).catch((err) => {
                if (seq !== this.listSeq) return;
                this.tableLoading = false;
                this.tableData = [];
                this.showError(err, '菜单列表加载失败');
            });
        },
        pageSizeChange(pageSize) {
            // 切换每页条数后回到第一页，否则可能停留在一个已不存在的页码上显示空列表
            this.page.pageSize = pageSize;
            this.page.currentPage = 1;
            this.loadList();
        },
        pageChange(page) {
            this.page.currentPage = page;
            this.loadList();
        },
        searchChange() {
            // 搜索必须回到第一页，否则结果条数不足时会停在上次的页码，看起来像"查不到"
            this.page.currentPage = 1;
            this.loadList();
        },
        refreshChange() {
            this.loadList();
        },
        /** 清空新增/编辑弹窗的临时状态，防止上一次的选择被带入下一次操作 */
        resetFormState() {
            this.menuType = {};
            this.superior = {};
            this.superiors = [];
        },
        /** 切换菜单类型：原上级菜单已不适用，必须清空后重新拉取 */
        onMenuTypeChange() {
            this.superior = {};
            this.loadSuperiors();
        },
        /** 按当前菜单类型加载可选上级菜单（带缓存与错误处理） */
        loadSuperiors() {
            const type = this.menuType && this.menuType.value;
            // 目录没有上级菜单，无需请求
            if (!type || type === 'DIRECTORY') {
                this.superiors = [];
                return;
            }
            if (this.superiorCache[type]) {
                this.superiors = this.superiorCache[type];
                return;
            }
            findSuperiorMenusByType(type).then((res) => {
                const data = this.parseResp(res, []);
                const list = Array.isArray(data) ? data : [];
                this.superiorCache[type] = list;
                // 请求返回期间用户可能已切换类型，需校验后再回填
                if (!this.menuType || this.menuType.value !== type) return;
                this.superiors = list;
            }).catch((err) => {
                this.superiors = [];
                this.showError(err, '上级菜单加载失败');
            });
        },
        /**
         * avue 的 xxxForm 插槽在编辑模式下会传入 value / disabled，
         * 在查看模式下只传 column / row，据此区分，避免查看时渲染成可操作的下拉框。
         */
        isViewScope(scope) {
            return !scope || !('value' in scope);
        },
        typeText(scope) {
            const val = scope && ('value' in scope ? scope.value : (scope.row && scope.row.type));
            const hit = this.menuTypes.find((item) => item.value === val);
            return hit ? hit.label : (val || '-');
        },
        /** 去掉 el-icon- 前缀，网格里只显示短名 */
        iconText(icon) {
            return (icon || '').replace(/^el-icon-/, '');
        },
        /** 打开图标选择器，记录当前编辑的表单行，选中后直接回填 */
        openIconPicker(row) {
            this.iconEditingRow = row;
            this.iconMode = 'common';
            this.iconKeyword = '';
            this.iconPage = 1;
            this.iconPickerVisible = true;
        },
        pickIcon(icon) {
            if (this.iconEditingRow) {
                // 直接改表单对象avue即可感知，无需额外同步
                this.$set(this.iconEditingRow, 'icon', icon);
            }
            this.iconPickerVisible = false;
            this.iconEditingRow = null;
        },
        /** 组装提交参数，统一裁剪首尾空格，避免"菜单名 "这类脏数据 */
        buildSubmitRow(row) {
            const data = Object.assign({}, row);
            ['name', 'uri', 'icon', 'permissionValue', 'remarks'].forEach((key) => {
                if (typeof data[key] === 'string') data[key] = data[key].trim();
            });
            data.type = this.menuType && this.menuType.value;
            if (data.type === 'DIRECTORY') {
                data.superiorId = null;
                data.superiorName = null;
            } else {
                data.superiorId = this.superior ? this.superior.id : undefined;
                data.superiorName = this.superior ? this.superior.name : undefined;
            }
            return data;
        },
        /** 补充 avue rules 覆盖不到的校验：菜单类型与上级菜单是自定义插槽，rules 管不到 */
        validateSubmit(data) {
            if (!data.type) {
                this.$message({ showClose: true, message: '请选择菜单类型', type: 'error' });
                return false;
            }
            if (data.type !== 'DIRECTORY' && !(this.superior && this.superior.id)) {
                this.$message({ showClose: true, message: '请选择上级菜单', type: 'error' });
                return false;
            }
            return true;
        },
        /**
         * @title 打开新增窗口
         * @detail 必须先清空上一次编辑残留的类型与上级菜单，否则会串数据
         */
        handleAdd() {
            this.resetFormState();
            this.$refs.crud.rowAdd();
        },
        /**
         * @title 打开编辑窗口
         * @detail 先拉完上级菜单再打开弹窗，否则下拉数据未到位，回显只会显示一个 id
         */
        handleEdit(row, index) {
            this.menuType = { value: row.type };
            this.superior = row.superiorId ? { id: row.superiorId } : {};
            const openDialog = () => this.$refs.crud.rowEdit(row, index);

            const type = row.type;
            if (!type || type === 'DIRECTORY') {
                this.superiors = [];
                openDialog();
                return;
            }
            if (this.superiorCache[type]) {
                this.superiors = this.superiorCache[type];
                openDialog();
                return;
            }
            findSuperiorMenusByType(type).then((res) => {
                const data = this.parseResp(res, []);
                const list = Array.isArray(data) ? data : [];
                this.superiorCache[type] = list;
                if (this.menuType && this.menuType.value === type) this.superiors = list;
                openDialog();
            }).catch(() => {
                this.superiors = [];
                openDialog();
            });
        },
        /**
         * @title 数据添加
         * @param row 为当前的数据
         * @param done 为表单关闭函数
         * @param loading 为表单按钮loading恢复函数
         */
        handleSave(row, done, loading) {
            const closeLoading = () => { if (typeof loading === 'function') loading(); };
            const data = this.buildSubmitRow(row);
            if (!this.validateSubmit(data)) {
                closeLoading();
                return;
            }
            addMenu(data).then((res) => {
                if (String(res && res.code) !== '200') {
                    this.$message({
                        showClose: true,
                        message: (res && res.message) || '添加失败',
                        type: "error"
                    });
                    closeLoading(); //失败时保留弹窗，避免已填内容丢失
                    return;
                }
                this.$message({ showClose: true, message: "添加成功", type: "success" });
                this.page.currentPage = 1; //按创建时间倒序，新增项在第一页
                this.loadList();
                this.resetFormState();
                closeLoading();
                done();
            }).catch((err) => {
                this.showError(err, '添加失败');
                closeLoading();
            });
        },
        /**
         * @title 数据删除
         * @param dicName 字典名
         * @param label 删除方式：逻辑删除 / 物理删除
         */
        handleDel(dicName, label) {
            const rows = (this.$refs.crud && this.$refs.crud.tableSelect) || [];
            if (rows.length == 0) {
                this.$message({ showClose: true, message: "请选择要操作的数据", type: "warning" });
                return;
            }
            const option = findByLabel(DIC.DELETE_OPTION, label);
            const isPhysical = option === 'PHYSICAL';
            const tip = isPhysical
                ? `物理删除将从数据库移除选中的 ${rows.length} 条菜单（含其子菜单关联），操作不可恢复，是否继续？`
                : `是否确认逻辑删除选中的 ${rows.length} 条菜单？`;

            this.$confirm(tip, isPhysical ? '危险操作' : '提示', {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: isPhysical ? 'error' : 'warning'
            }).then(() => {
                const ids = rows.map((row) => row.id);
                return delMenu(option, ids).then((res) => {
                    if (String(res && res.code) !== '200') {
                        this.$message({
                            showClose: true,
                            message: (res && res.message) || '删除失败',
                            type: "error"
                        });
                        return;
                    }
                    this.$message({ showClose: true, message: "删除成功", type: "success" });
                    // 删完当前页若已无数据且不在第一页，回退一页，避免出现空白列表
                    const left = (this.page.total || 0) - ids.length;
                    const maxPage = Math.max(1, Math.ceil(left / this.page.pageSize));
                    if (this.page.currentPage > maxPage) this.page.currentPage = maxPage;
                    this.loadList();
                });
            }).catch((err) => {
                // 点取消/关闭属于正常流程，不提示
                if (err === 'cancel' || err === 'close') return;
                this.showError(err, '删除失败');
            });
        },
        /**
         * @title 数据更新
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         * @param done 为表单关闭函数
         * @param loading 为表单按钮loading恢复函数
         */
        handleUpdate(row, index, done, loading) {
            const closeLoading = () => { if (typeof loading === 'function') loading(); };
            const data = this.buildSubmitRow(row);
            if (!this.validateSubmit(data)) {
                closeLoading();
                return;
            }
            editMenu(data).then((res) => {
                if (String(res && res.code) !== '200') {
                    this.$message({
                        showClose: true,
                        message: (res && res.message) || '修改失败',
                        type: "error"
                    });
                    closeLoading(); //失败时保留弹窗，避免已填内容丢失
                    return;
                }
                this.$message({ showClose: true, message: "修改成功", type: "success" });
                // 类型/名称变更会影响上级菜单下拉，清空缓存
                this.superiorCache = {};
                this.loadList();
                closeLoading();
                done();
            }).catch((err) => {
                this.showError(err, '修改失败');
                closeLoading();
            });
        }
    }
};
</script>

<style lang="scss">
.table-container {
    padding: 8px 10px;
}

.form-tip {
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.5;
    color: #909399;
}

.icon-field {
    display: flex;
    align-items: center;

    .el-button {
        margin-left: 8px;
        white-space: nowrap;
    }
}

.icon-preview {
    i {
        margin-right: 6px;
        font-size: 16px;
        vertical-align: middle;
    }
}

.icon-cell {
    font-size: 18px;
    color: #606266;
}

.icon-picker {
    &__bar {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
    }

    &__search {
        width: 240px;
        margin-left: 12px;
    }

    &__grid {
        // 用 flex 而非 grid，兼容低版本浏览器
        display: flex;
        flex-wrap: wrap;
        max-height: 380px;
        overflow-y: auto;
    }

    &__empty {
        padding: 48px 0;
        text-align: center;
        color: #909399;
    }

    &__page {
        margin-top: 12px;
        text-align: right;
    }

    &__count {
        float: left;
        font-size: 12px;
        line-height: 28px;
        color: #909399;
    }
}

.icon-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: calc(12.5% - 8px);
    margin: 4px;
    padding: 10px 4px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    cursor: pointer;
    transition: all .15s;

    i {
        font-size: 20px;
        color: #606266;
    }

    span {
        max-width: 100%;
        margin-top: 6px;
        overflow: hidden;
        font-size: 11px;
        color: #909399;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &:hover {
        border-color: #409eff;
        background: #ecf5ff;

        i,
        span {
            color: #409eff;
        }
    }

    &.is-active {
        border-color: #409eff;
        background: #409eff;

        i,
        span {
            color: #fff;
        }
    }
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}

// 小屏下操作列容易挤压出血，放开横向滚动；图标网格每行减为 4 个
@include mobile {
    .menu-page .el-table {
        overflow-x: auto;
    }

    .icon-item {
        width: calc(25% - 8px);
    }

    .icon-picker__search {
        width: 160px;
    }
}
</style>
